import MasterLayout from "../otherImages/MasterLayout";
import DefaultTopBar from "../components/DefaultTopBar";
import FreeTapeList from "../components/FreeTapeList";

const FreeTapeListPage = () => {
  return (
    <MasterLayout>
      <DefaultTopBar title="Free Tape Requests" />
      <FreeTapeList />
    </MasterLayout>
  );
};

export default FreeTapeListPage;